import {createAsyncThunk} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
    addNewProject as addNewProjectApi,
    deleteProject as deleteProjectApi,
    getProjectById as getProjectByIdApi,
    getProjectPhasesById as getProjectPhasesByIdApi,
    getProjects as getProjectsApi,
    updateProject as updateProjectApi
} from "../../helpers/fakebackend_helper";

// Fetch Projects
export const getProjects = createAsyncThunk("projects", async () => {
  try {
      return await getProjectsApi();
  } catch (error) {
    toast.error("Failed to fetch projects", { autoClose: 3000 });
    throw error;
  }
});

// Fetch Project by ID
export const getProjectById = createAsyncThunk(
  "projects/getProjectById",
  async (id) => {
    try {
      const response = await getProjectByIdApi(id); // Call the API to get a project by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch project by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

export const getProjectPhasesById = createAsyncThunk(
  "projects/getProjectPhasesById",
  async (id) => {
    try {
      const response = await getProjectPhasesByIdApi(id); // Call the API to get a project by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch project phases by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

// Add New Project
export const addNewProject = createAsyncThunk(
  "projects/addProject",
  async (newProject) => {
    try {
      const response = await addNewProjectApi(newProject);
      toast.success("Project Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add project", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update Project
export const updateProject = createAsyncThunk(
  "projects/updateProject",
  async (project) => {
    try {
      const response = await updateProjectApi(project);
      toast.success("Project Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to update project", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete Project
export const deleteProject = createAsyncThunk(
  "projects/deleteProject",
  async (projectId) => {
    try {
      const response = await deleteProjectApi(projectId);
      toast.success("Project Deleted Successfully", { autoClose: 3000 });
      return { projectId, ...response };
    } catch (error) {
      toast.error("Failed to delete project", { autoClose: 3000 });
      throw error;
    }
  }
);
